<template>
  <v-app>
    <PortfolioDialog />
    <PortfolioGalleryDialog />
    <CoreNavBar />

    <v-content class="pa-0">
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
export default {

}

/**
 * Colour theme:
 * #BA7DFF - rgba(179,121,247) : purple
 * #FFD496 - rgba(255,212,150) : light orange
 * #4FB36C - rgba(79,179,108) : green
 * #707BFF - rgba(112,123,255) : blue
 * #FF8AFC - rgba(255,138,252) : pink
 * black: rgba(30, 37, 40)
 * turquoise: rgba(26, 188, 156)
 */
</script>

<style lang="scss">
#app {
  background: #fff;
}
</style>

